import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { RequestBodyContact } from '../../../../core/models/request-body.model';
import { BaseApiService } from '../../../../shared/services/api';

@Injectable({
  providedIn: 'root'
})
export class ContactinboxService {
    contactSearchCriteria: RequestBodyContact;
    searchURL = 'service/contactcloud/search/';
    contactListScrollPosition = 0;
    totalInboxContactsCount = 0;
    revealMatchId: any;
    contactLoadedFlag = new BehaviorSubject(false);
    listLoadedFlag = new BehaviorSubject(false);
    createContactLoadedFlag = new BehaviorSubject(false);
    resultPage = {
        IsNavigating: false,
        resultData: [],
        totalHumanVerifiedCount: 0,
        totalPendingVerifiedCount: 0,
        contactSidebarData: null,
        contactsSortedBy: '',
        contactsSortedByDirection: ''

    };
    contactResultParams = {
        page: 1,
        pageSize: 0,
        resultCount: 0,
        totalCount: 0
    };
    contactInternational = new BehaviorSubject(0);
    isContactInternational = 0;
    contactRequestCriteria;
    lastVerifiedStatus;
    contactPageNumber = 1;
    constructor(
        private readonly baseApiService: BaseApiService,
    ) {
        this.contactInternational.subscribe((internationData) => this.isContactInternational = internationData);
    }


    getInboxIntelContacts(ids, page, verifiedStatus) {
        this.lastVerifiedStatus = verifiedStatus;
        return this.baseApiService.get<any>('service/contactcloud/inboxIntel/contacts?externalPrincipalId=' + ids + '&page=' + page + '&verifiedStatus=' + verifiedStatus, { excludeImpersonate: true, showError: true });
    }

    deleteInboxIntelContacts(data) {
        return this.baseApiService.post('service/contactcloud/inboxIntel/deleteContacts', data, { excludeImpersonate: true });
    }

    exportToSalesforce(inboxIntelContactIds) {
        return this.baseApiService.post('service/contactcloud/inboxIntel/savedContactsToSalesforce', { inboxIntelContactIds }, { excludeImpersonate: true });
    }

    tagInboxIntelContacts(body) {
        return this.baseApiService.post('service/contactcloud/inboxIntel/savedContactsToSalesIntel', body, { excludeImpersonate: true, showError: true });
    }


}
